import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useMutation } from '@apollo/client';
import { SHOPIFY_LOGIN, SHOPIFY_INSTALL } from '../graphql/queries';

export default function ShopifyAuth() {
  const { search } = useLocation();
  const navigate = useNavigate();
  const params = Object.fromEntries(new URLSearchParams(search).entries());

  const [status, setStatus] = useState('Processing...');

  const [shopifyLogin] = useMutation(SHOPIFY_LOGIN);
  const [shopifyInstall] = useMutation(SHOPIFY_INSTALL);

  useEffect(() => {
    if ('code' in params) {
      handleInstall();
    } else if ('shop' in params) {
      handleLogin();
    } else {
      setStatus('Invalid Access');
    }
  }, []); // eslint-disable-line  react-hooks/exhaustive-deps

  const handleLogin = async () => {
    try {
      setStatus('Authenticating...');
      const inputData = {
        hmac: params.hmac,
        host: params.host,
        session: params.session,
        shop: params.shop,
        timestamp: params.timestamp,
      };

      const { data } = await shopifyLogin({ variables: { input: inputData } });
      const result = data?.shopifyLogin;

      if (result?.error === false && result?.redirectUrl) {
        window.location.href = result.redirectUrl;
        return;
      }

      if (!result?.error && !result?.redirectUrl) {
        sessionStorage.setItem('shopify-shop-id', result?.data?.shopId);
        sessionStorage.setItem('websiteType', 'shopify');
        navigate('/dashboard', { replace: true });
      }
    } catch (error) {
      console.log('ShopifyLogin error:', error);
      setStatus('Authentication failed. Please try again.');
    }
  };

  const handleInstall = async () => {
    try {
      setStatus('Installing...');
      const inputData = {
        hmac: params.hmac,
        host: params.host,
        session: params.session,
        shop: params.shop,
        timestamp: params.timestamp,
        code: params.code,
      };

      const { data } = await shopifyInstall({ variables: { input: inputData } });
      const result = data?.shopifyInstall;

      if (result?.error === false && result?.redirectUrl) {
        window.location.href = result.redirectUrl;
        return;
      }

      if (!result?.error && !result?.redirectUrl) {
        sessionStorage.setItem('shopify-shop-id', result?.data?.shopId);
        sessionStorage.setItem('websiteType', 'shopify');
        navigate('/dashboard', { replace: true });
      }
    } catch (error) {
      console.log('ShopifyInstall error:', error);
      setStatus('Installation failed. Please try again.');
    }
  };

  return (
    <div className="centered-page">
      <div className="centered-box">
        <div className="icon-circle icon-circle--yellow">
          <div
            style={{
              width: 28,
              height: 28,
              border: '3px solid #e5e7eb',
              borderTop: '3px solid #6366f1',
              borderRadius: '50%',
              animation: 'spin 1s linear infinite',
            }}
          />
        </div>
        <h1 className="heading-xl">{status}</h1>
        <p className="text-muted">
          {'code' in params
            ? 'Installation in progress, please wait.'
            : 'Please wait while we process your request.'}
        </p>
        <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
      </div>
    </div>
  );
}
